const closeMenuOnLink = () => {
    const page = document.querySelector('.ekospray-graco'),
          headerBurger = document.querySelector('.header-burger'),
          links = document.querySelectorAll('.header-menu__sections ul.accordion > li');

    if (page) {
        links.forEach(link => link.addEventListener('click', () => {
            headerBurger.classList.remove('open');
            document.querySelector('html').classList.remove('no-admin-bar');
        }))
    }
}

export default closeMenuOnLink;